var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcAlert(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "ic-alert-a",
    d: "M15,5 C9.4771525,5 5,9.4771525 5,15 C5,20.5228475 9.4771525,25 15,25 C20.5228475,25 25,20.5228475 25,15 C25,9.4771525 20.5228475,5 15,5 Z M15,12.5 C15.6903559,12.5 16.25,13.0596441 16.25,13.75 L16.25,20 C16.25,20.6903559 15.6903559,21.25 15,21.25 C14.3096441,21.25 13.75,20.6903559 13.75,20 L13.75,13.75 C13.75,13.0596441 14.3096441,12.5 15,12.5 Z M15,11.25 C14.3096441,11.25 13.75,10.6903559 13.75,10 C13.75,9.30964406 14.3096441,8.75 15,8.75 C15.6903559,8.75 16.25,9.30964406 16.25,10 C16.25,10.6903559 15.6903559,11.25 15,11.25 Z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#FFA91F",
    transform: "rotate(-180 15 15)",
    xlinkHref: "#ic-alert-a"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcAlert);
export default __webpack_public_path__ + "static/media/ic-alert.b3e00ffa.svg";
export { ForwardRef as ReactComponent };